// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/shop/daily_bg_idle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@assets/shop/daily_bg_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@assets/shop/daily_title_bar.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@assets/shop/black_info_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("@assets/inventory/box_btn_idle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("@assets/shop/daily_button.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shop-card-container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% 100%;
    padding: 14px;
    min-width: 196px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    cursor: pointer;
}

.shop-card-container:hover {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.shop-card-title {
    padding: 4px 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: 100% 100%;
    width: 94%;
}

.shop-card-title-name {
    max-width: 82px;
    overflow: hidden;
    text-overflow: ellipsis;
    /* white-space: nowrap; */
}

.equipment-card-info-box {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: 100% 100%;
    padding: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
}

.equipment-card-info-box .equipment-card-info-lv {
    color: #FFFFFF;
}

.shop-card-title span {
    font-size: 14px;
    font-weight: 600;
    color: #FFFFFF;
}

.equipment-card-info-container {
    display: flex;
    justify-content: center;
    gap: 4px;
}

.equipment-card-info-box span {
    font-size: 12px;
    color: #71deff;
}

.equipment-card-info-box img {
    width: 12px;
    height: 12px;
}

.equipment-card-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    box-sizing: border-box;
    padding: 0 4px;
    width: 100%;
    position: relative;
}

.equipment-card-content .shop-portrait {
    margin-left: 75px;
}

.equipment-card-class-badge {
    position: absolute;
    top: 0;
    left: 0;
    width: 32px;
    height: 32px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
}

.equipment-card-class-badge img {
    width: 72%;
    height: 72%;
}

.equipment-card-description {
    text-align: center;
    font-size: 14px;
    max-width: 174px;
    /* height: 32px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis; */
}

.shop-card-effect-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 4px;
    width: 100%;
    padding: 4px 0;
}

.shop-card-effect {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 4px;
    background-color: #16181c;
    border-radius: 4px;
    overflow: hidden;
    width: 96px;
    height: 26px;
    position: relative;
}

.shop-card-effect span {
    font-size: 14px;
}

.shop-card-effect-stat {
    position: absolute;
    top: 0;
    left: 0;
    width: 50px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    color: #FFFFFF;
}

.shop-card-effect-value {
    padding: 4px 12px;
    line-height: 12px;
}

.shop-card-price {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: 100% 100%;
    padding: 8px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    color: #FFFFFF;
    font-size: 14px;
    width: 100%;
    margin-bottom: 4px;
}

.shop-card-price img {
    width: 14px;
    height: 14px;
}

.shop-card-class-container {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.shop-card-class {
    width: 20px;
    height: 20px;
    padding: 4px;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.shop-card-class img {
    width: 12px;
    height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/shopEquipmentCard/ShopEquipmentCard.style.css"],"names":[],"mappings":"AAAA;IACI,yDAAuD;IACvD,0BAA0B;IAC1B,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yDAAyD;IACzD,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,yDAAuD;IACvD,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,sBAAsB;IACtB,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAA2D;IAC3D,0BAA0B;IAC1B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;;;;;8BAK0B;AAC9B;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,yDAAsD;IACtD,0BAA0B;IAC1B,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".shop-card-container {\n    background-image: url('@assets/shop/daily_bg_idle.png');\n    background-size: 100% 100%;\n    padding: 14px;\n    min-width: 196px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 6px;\n    cursor: pointer;\n}\n\n.shop-card-container:hover {\n    background-image: url('@assets/shop/daily_bg_active.png');\n}\n\n.shop-card-title {\n    padding: 4px 6px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-image: url('@assets/shop/daily_title_bar.png');\n    background-size: 100% 100%;\n    width: 94%;\n}\n\n.shop-card-title-name {\n    max-width: 82px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    /* white-space: nowrap; */\n}\n\n.equipment-card-info-box {\n    background-image: url('@assets/shop/black_info_bg.png');\n    background-size: 100% 100%;\n    padding: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n}\n\n.equipment-card-info-box .equipment-card-info-lv {\n    color: #FFFFFF;\n}\n\n.shop-card-title span {\n    font-size: 14px;\n    font-weight: 600;\n    color: #FFFFFF;\n}\n\n.equipment-card-info-container {\n    display: flex;\n    justify-content: center;\n    gap: 4px;\n}\n\n.equipment-card-info-box span {\n    font-size: 12px;\n    color: #71deff;\n}\n\n.equipment-card-info-box img {\n    width: 12px;\n    height: 12px;\n}\n\n.equipment-card-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    box-sizing: border-box;\n    padding: 0 4px;\n    width: 100%;\n    position: relative;\n}\n\n.equipment-card-content .shop-portrait {\n    margin-left: 75px;\n}\n\n.equipment-card-class-badge {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 32px;\n    height: 32px;\n    background-image: url('@assets/inventory/box_btn_idle.png');\n    background-size: 100% 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 12px;\n}\n\n.equipment-card-class-badge img {\n    width: 72%;\n    height: 72%;\n}\n\n.equipment-card-description {\n    text-align: center;\n    font-size: 14px;\n    max-width: 174px;\n    /* height: 32px;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n    text-overflow: ellipsis; */\n}\n\n.shop-card-effect-container {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 4px;\n    width: 100%;\n    padding: 4px 0;\n}\n\n.shop-card-effect {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 4px;\n    background-color: #16181c;\n    border-radius: 4px;\n    overflow: hidden;\n    width: 96px;\n    height: 26px;\n    position: relative;\n}\n\n.shop-card-effect span {\n    font-size: 14px;\n}\n\n.shop-card-effect-stat {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 50px;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 600;\n    color: #FFFFFF;\n}\n\n.shop-card-effect-value {\n    padding: 4px 12px;\n    line-height: 12px;\n}\n\n.shop-card-price {\n    background-image: url('@assets/shop/daily_button.png');\n    background-size: 100% 100%;\n    padding: 8px 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n    color: #FFFFFF;\n    font-size: 14px;\n    width: 100%;\n    margin-bottom: 4px;\n}\n\n.shop-card-price img {\n    width: 14px;\n    height: 14px;\n}\n\n.shop-card-class-container {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.shop-card-class {\n    width: 20px;\n    height: 20px;\n    padding: 4px;\n    background-size: 100% 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.shop-card-class img {\n    width: 12px;\n    height: 16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
